export const coreConstantsGeneralUIs = {
	CoreGeneralQuestion: 'Core-General-Question',
	CoreGeneralFeedback: 'Core-General-Feedback',
	CoreGeneralAAR: 'Core-General-AAR',
	CoreLoadingUI: 'CoreLoadingUI'
}